import React, {Suspense} from 'react';

const UserComponent = React.lazy(() => import('../Component/UserComponent/UserComponent'));

function UserPage(props) {
    return (
        <>
            <Suspense fallback={<div>Loading...</div>}>
                <UserComponent/>
            </Suspense>
        </>
    );
}

export default UserPage;